module.exports = __webpack_public_path__ + "cb680b4b896ef7c389c9791a959dce1b.jpg";